const APP_PREFIXES = [
  '/dashboard',
  '/orders',
  '/replenishables',
  '/returns',
  '/inventory-costs',
  '/inventory-insights',
  '/shipments',
  '/settings',
  '/amazon/callback',
];

export function safeNextPath(raw: string | null | undefined, fallback = '/dashboard'): string {
  if (!raw) return fallback;
  if (!raw.startsWith('/') || raw.startsWith('//') || raw.includes('://')) return fallback;
  const path = raw.split('?')[0];
  if (path === '/' || path === '/login' || path === '/signup' || path === '/forgot-password') {
    return fallback;
  }
  if (APP_PREFIXES.some((prefix) => path === prefix || path.startsWith(`${prefix}/`)) || path === '/reset-password') {
    return raw;
  }
  return fallback;
}

export function loginRedirect(pathname: string, search = ''): string {
  const next = `${pathname}${search}`;
  return `/login?next=${encodeURIComponent(safeNextPath(next))}`;
}
